import { useState } from "react";
import { Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { Button, FormGroup, Label } from "reactstrap";
import styles from "./Forgot.module.scss";
import passEye from "../../resources/images/pwdEye.svg";
import hideEye from "../../resources/images/hideEye.svg";

const ForgotPasswordForm = (props) => {
  const navigate = useNavigate();
  const { errors, touched } = props;
  const [eye, seteye] = useState(true);
  const [password, setpassword] = useState("password");
  const [ceye, setCeye] = useState(true);
  const [cpassword, setCpassword] = useState("password");

  const Eye = () => {
    if (password === "password") {
      setpassword("text");
      seteye(false);
    } else {
      setpassword("password");
      seteye(true);
    }
  };
  const ConfirmEye = () => {
    if (cpassword === "password") {
      setCpassword("text");
      setCeye(false);
    } else {
      setCpassword("password");
      setCeye(true);
    }
  };
  return (
    <Form
      className={`${styles.forgotForm} d-flex flex-column justify-content-center forgotPwd`}
    >
      <h3 className={styles.loginHeading}>Reset password</h3>
      <FormGroup className="form-group">
        <Label>Password</Label>
        <div className="input-text">
          <Field
            name="password"
            type={password}
            className="form-control"
          //  placeholder="Enter password"
          />
          <img
            onClick={Eye}
            className="eye-icons"
            src={eye ? hideEye : passEye}
            alt=""
          />
        </div>
        {errors.password && touched.password ? (
          <div className={styles.formError}>{errors.password}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label>Confirm Password</Label>
        <div className="input-text">
          <Field
            name="cpassword"
            type={cpassword}
            className="form-control"
          //  placeholder="Enter confirm password"
          />
          <img
            onClick={ConfirmEye}
            className="eye-icons"
            src={ceye ? hideEye : passEye}
            alt=""
          />
        </div>
        {errors.cpassword && touched.cpassword ? (
          <div className={styles.formError}>{errors.cpassword}</div>
        ) : null}
      </FormGroup>
      <p
        className={`ms-auto ${styles.resetPwd}`}
        onClick={() => navigate("/login")}
      >
        Back To Login
      </p>
      <Button
        type="submit"
        disabled={props?.submited}
        className={styles.brandButton}
      >
        {props?.submited && (
          <span className="spinner-border spinner-border-sm mr-1"></span>
        )}
        Reset Password
      </Button>
    </Form>
  );
};

export default ForgotPasswordForm;
